import * as React from 'react';
import { classes, style, stylesheet } from 'typestyle';
import { Black, Blood, Blue, GrayCream, GrayDark, White } from '../../../styles/colors';
import { ArrowDropdownIcon } from '../../atoms/icons/Icons';
import Label from '../../atoms/Label';
import { smallStyle } from '../../..';
import { ButtonStyleTypes } from '../../../styles/button';
import ListItemText from '../list/ListItemText';
import ListItem from '../list/ListItem';
import Button from '../buttons/Button';
import { borderPx, errMsgStyle, inputContainerStyle, inputDefaultBorderColor, leftPaddingStyle, titleStyle, } from '../../../styles/input';
export const DropdownBtnStylesSet = {
    common: {
        styleType: ButtonStyleTypes.ActiveB,
        icon: React.createElement(ArrowDropdownIcon, { color: Blue }),
    },
    active: {
        styleType: ButtonStyleTypes.ActiveA,
        icon: React.createElement(ArrowDropdownIcon, { color: White }),
    },
    disabled: {
        styleType: ButtonStyleTypes.Disabled,
        icon: React.createElement(ArrowDropdownIcon, { color: GrayDark }),
    },
    error: {
        styleType: ButtonStyleTypes.WarnA,
        icon: React.createElement(ArrowDropdownIcon, { color: White }),
    },
};
class SelectInput extends React.Component {
    constructor(props) {
        super(props);
        this.handleChangeFocus = (focused) => {
            this.setState({ focused });
        };
        this.state = {
            focused: !!props.focused,
        };
        this.handleClick = this.handleClick.bind(this);
    }
    handleClick() {
        this.props.onClick();
    }
    render() {
        const { name, value, title, icon, dropdownButton, placeholder, errorMessage, className, isInvalid = false, disabled = false, active = false, } = this.props;
        const { focused } = this.state;
        const noValue = !value;
        const showPlaceholder = noValue;
        const showTitle = !showPlaceholder || disabled;
        const dropdownButtonProps = Object.assign(Object.assign(Object.assign(Object.assign({}, DropdownBtnStylesSet.common), (disabled && Object.assign({}, DropdownBtnStylesSet.disabled))), (active && Object.assign({}, DropdownBtnStylesSet.active))), (isInvalid && Object.assign({}, DropdownBtnStylesSet.error)));
        return (React.createElement("div", { className: classes('ta-select-input-container', inputContainerStyle, className) },
            title && showTitle && (React.createElement(Label, { title: title, className: classes(titleStyle.common, smallStyle, focused && !isInvalid && titleStyle.focused, active && !isInvalid && titleStyle.focused, isInvalid && titleStyle.error) })),
            React.createElement("div", { className: classes('ta-select-input', selectInputStyle.common, disabled && selectInputStyle.disabled, title && showTitle && selectInputStyle.showTitle, noValue && selectInputStyle.noValue, active && selectInputStyle.active, isInvalid && selectInputStyle.error) },
                React.createElement(ListItem, { key: `${name}-select-item`, small: true, hideLeftCell: !icon, leftCell: icon, className: classes(!icon && leftPaddingStyle, style({
                        paddingRight: 4,
                    })), onClick: !disabled ? this.handleClick : () => { }, disabled: disabled, rightCell: dropdownButton ? dropdownButton : React.createElement(Button, Object.assign({ small: true, naked: true }, dropdownButtonProps, { onClick: () => { } })), centerCell: React.createElement(ListItemText, { title: showPlaceholder ? placeholder : value }) })),
            errorMessage && isInvalid && React.createElement(Label, { title: errorMessage, className: classes(errMsgStyle, smallStyle) })));
    }
}
export default SelectInput;
const selectInputStyle = stylesheet({
    common: {
        cursor: 'pointer',
        background: White,
        boxShadow: `inset 0px 0px 0px ${borderPx}px ${inputDefaultBorderColor}`,
        boxSizing: 'border-box',
        borderRadius: 12,
    },
    noValue: {
        $nest: {
            '& .tds-list-item-text': {
                color: `${Blue} !important`,
            },
        },
    },
    disabled: {
        background: GrayCream,
        $nest: {
            '& .tds-list-item-text': {
                color: `${GrayDark} !important`,
            },
        },
    },
    showTitle: {
        $nest: {
            '& .ta-center-cell': {
                justifyContent: 'flex-end',
            },
        },
    },
    active: {
        boxShadow: `inset 0px 0px 0px ${borderPx}px ${Blue}`,
        $nest: {
            '& .tds-list-item-text': {
                color: `${Black} !important`,
            },
        },
    },
    error: {
        boxShadow: `inset 0px 0px 0px ${borderPx}px ${Blood}`,
        color: `${Blood} !important`,
        $nest: {
            '& .tds-list-item-text': {
                color: `${Blood} !important`,
            },
        },
    },
});
//# sourceMappingURL=SelectInput.js.map